module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAQCAMAAAAs2N9uAAAAhFBMVEUAAACdnZ2ZmZmZmZmYmJiWlpaYmJiXl5eZmZmWlpabm5uYmJiZmZmbm5uZmZmampqYmJiZmZmampqZmZmZmZmampqZmZmampqZmZmZmZmampqZmZmZmZmZmZmYmJiampqZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZm2zkxuAAAAK3RSTlMAGiMoKi40Ozw9PUVGSlBYWWRlcYSLk5ylrbCxssjJycvQ1eHi7u/1+vv9eLpzXAAAAHRJREFUGNO9i2kWQ0AQBj/EIMkQsUssQbTh/vezteQG6ke/6nrdAKAV47QxFhp2wtq8bJh1yClOWZDG62yIBkWMGoga6ELY4sei+nrYXo9Hp2PpJQIP8J+Q/T9lEZAkZybXAu43yC+nKn8wecnJeH2Yt7GsM6gKDfMaub3EAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/images/垃圾桶.png
// module id = oJdn
// module chunks = 1